import { render, staticRenderFns } from "./MyRequests.vue?vue&type=template&id=cb5580da"
import script from "./MyRequests.vue?vue&type=script&lang=js"
export * from "./MyRequests.vue?vue&type=script&lang=js"
import style0 from "./MyRequests.vue?vue&type=style&index=0&id=cb5580da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports